import { render } from "./HistoryTable.vue?vue&type=template&id=17ad45a7&scoped=true"
import script from "./HistoryTable.vue?vue&type=script&lang=ts"
export * from "./HistoryTable.vue?vue&type=script&lang=ts"

import "./HistoryTable.vue?vue&type=style&index=0&id=17ad45a7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-17ad45a7"

export default script